var Connection = require('connection');
var FileWrapper = require('filewrapper');
var IRCFormatter = require('ircformatter');
var util = require('../lib/util.es6');
var uriTemplates = require('uri-templates');

var urlUtil = require('../lib/url.es6');
var re = require('../lib/re.es6');

var VIDEO_WIDTH = 416;
var VIDEO_HEIGHT = 234;

var image_ext_parts = ['jpe?g', 'gif', 'png', 'webp'];
var IMAGE_EXT_RE = new RegExp('\\.' + re.c(re.oneOf(image_ext_parts)) + '$');

var CHAN_PREFIX_CHARS = '#＃';
var EMOJI_HASH_SUFFIX = '\\ufe0e\\ufe0f\\u20e3';
var BAD_CHAN_CHARS = '<>",\\s';

var QUOTES = {
    '"': '"',
    "'": "'",
    ')': '(',
    ']': '[',
    '}': '{',
    '>': '<',
    '”': '“',
    '’': '‘',
    '»': '«',
    '`': '`'
};

var regexCache = {};

var linker = function (formatter) {
    this.formatter = formatter;
    this.buffer = formatter.buffer;
    this.setRegex();
    if (this.buffer) {
        this.listenTo(this.buffer.connection, 'iSupportChange', this.setRegex);
    }
};
_.extend(linker.prototype, Backbone.Events, {
    setRegex: function () {
        this.chanPrefix = this.buffer ? this.buffer.connection.getChannelPrefixes() : CHAN_PREFIX_CHARS;
        if (regexCache[this.chanPrefix]) {
            this.chanRegex = regexCache[this.chanPrefix].chanRegex;
            this.chanRegexStart = regexCache[this.chanPrefix].chanRegexStart;
            this.regex = regexCache[this.chanPrefix].regex;
        } else {
            this.chanRegex = re.isA(re.escape(this.chanPrefix)) +
                re.notA(EMOJI_HASH_SUFFIX + BAD_CHAN_CHARS) +
                re.atLeastNone(re.notA(BAD_CHAN_CHARS));
            this.chanRegexStart = new RegExp('^' + this.chanRegex),
            this.regex = new RegExp(re.oneOf(urlUtil.getParts(this.chanRegex)), 'gi');
            regexCache[this.chanPrefix] = {
                chanRegex: this.chanRegex,
                chanRegexStart: this.chanRegexStart,
                regex: this.regex
            };
        }
    },
    isChannelName: function (string) {
        return !!string.match(this.chanRegexStart);
    },
    isCurrentUrl: function (urlParts) {
        return urlUtil.isCurrentUrl(urlParts);
    },
    isImage: function (urlParts) {
        var re = IMAGE_EXT_RE;
        return re.test(urlParts.pathname.toLowerCase()) ||
               re.test(urlParts.search.toLowerCase()) ||
               re.test(urlParts.hash.toLowerCase());
    },
    imageUrl: function (urlParts, url, message) {
        if (this.fileParts(urlParts, message)) {
            return;
        }
        if (this.isAttachmentImage(url, message)) {
            return;
        }
        urlParts.protocol = 'https:';
        if (urlParts.hostname.match(/^(?:www\.)?dropbox\.com$/i)) {
            var dropboxMatch = urlParts.pathname.match(/^\/s\/([^\/&]+)\/([^\/&]+)\/?$/);
            if (dropboxMatch) {
                return 'https://dl.dropboxusercontent.com/s/' + dropboxMatch[1] + '/' + dropboxMatch[2];
            }
        } else if (urlParts.hostname.match(/^pbs\.twimg\.com$/i)) {
            var twimgMatch = urlParts.pathname.match(/^\/media\/([^\/:]+)(:\w+)?\/?$/);
            if (twimgMatch) {
                return 'https://pbs.twimg.com/media/' + twimgMatch[1] + '?format=jpg&name=small';
            }
        } else if (urlParts.hostname.match(/^droplr\.com$/i) || urlParts.hostname.match(/^d\.pr$/i)) {
            var dprMatch = urlParts.pathname.match(/^\/i\/([^\/+]+)/);
            if (dprMatch) {
                return 'https://d.pr/i/' + dprMatch[1] + '+';
            }
        } else if (urlParts.hostname.match(/\.steam(?:powered|usercontent)\.com$/i)) {
            var steamMatch = urlParts.pathname.match(/^\/ugc\/([^\/&]+)\/([^\/&]+)\/?/);
            if (steamMatch) {
                return urlParts.href;
            }
        } else if (urlParts.hostname.match(/^lh\d+\.(googleusercontent)|(ggpht)\.com$/i)) {
            return urlParts.href;
        } else if (urlParts.hostname.match(/i\.reddituploads\.com$/i)) {
            return urlParts.href;
        }
        if (this.isImage(urlParts)) {
            return urlParts.href;
        }
    },
    singleImage: function (message, options) {
        options = options || {};
        var image;
        var embeds = message.getEmbeds();
        if (options.files) {
            if (embeds && embeds.files) {
                _.any(embeds.files, function (file) {
                    if (!file.id) {
                        return false;
                    }
                    var fw = new FileWrapper(file);
                    if (fw.isPreviewable()) {
                        image = fw.getUrl();
                        return true;
                    }
                    return false;
                }, this);
            }
        }
        if (!image && options.images) {
            var urlSplitParts = this.splitTextOnUrls(IRCFormatter.strip(message.get('msg')), 0);
            _.any(urlSplitParts, function (part, index) {
                if (part.url) {
                    var urlParts = urlUtil.urlParts(part.url);
                    if (urlParts) {
                        image = this.imageUrl(urlParts, part.url, message);
                        if (image) {
                            return true;
                        }
                    }

                }
            }, this);
        }
        if (!image && message.buffer.imageAvatarsEnabled()) {
            var avatar = message.getAvatar();
            if (avatar) {
                image = uriTemplates(avatar.src).fill({
                    size: 128
                });
            }
        }
        return image;
    },
    gistParts: function (urlParts) {
        var gistMatch;
        if (urlParts.hostname.match(/^gist\.github\.com$/i)) {
            gistMatch = urlParts.pathname.match(/^\/(?:([^\/&]+)\/)?([^\/\.&]+)\/?$/);
        }
        if (gistMatch && gistMatch[2] && (
            urlUtil.isNum(gistMatch[2]) || gistMatch[2].length >= 20
        )) {
            return {
                gist_owner: gistMatch[1],
                gist_id: gistMatch[2],
                gist_hash: urlParts.hash
            };
        }
    },
    host: function () {
        return this.buffer ? this.buffer.session.getHost() : window.location.hostname;
    },
    fileHost: function () {
        return window.IRCConfig.file_upload_domain;
    },
    pasteParts: function (urlParts) {
        var pasteMatch;
        if (urlParts.hostname == this.host()) {
            pasteMatch = urlParts.pathname.match(/^\/pastebin\/([^\/\.&]+)/);
        }
        if (pasteMatch) {
            return {
                paste_id: pasteMatch[1],
            };
        }
    },
    fileParts: function (urlParts, message) {
        if (message) {
            var embeds = message.getEmbeds();
            if (embeds && embeds.files) {
                if (urlParts.hostname == this.host() || urlParts.hostname == this.fileHost()) {
                    var fileMatch = urlParts.pathname.match(/^\/file\/(.+)/);
                    if (fileMatch) {
                        var pathParts = fileMatch[1].split('/');
                        var file = _.find(embeds.files, function (f) {
                            if (_.include(pathParts, f.id)) {
                                return true;
                            }
                        });
                        if (file) {
                            return {
                                file_id: file.id
                            };
                        }
                    }
                }
            }
        }
    },
    isAttachmentImage: function (url, message) {
        if (message) {
            var attachments = message.getAttachmentsJson();
            var concatParent = message.getConcatParent();
            if (concatParent) {
                attachments = attachments.concat(concatParent.getAttachmentsJson());
            }
            return !!_.find(attachments, function (attach) {
                if (
                    url === attach.from_url ||
                    url === attach.title_link ||
                    url === attach.file_url
                ) {
                    return true;
                }
            });
        }
        return false;
    },
    twitchParts: function (urlParts) {
        var twitchMatch;
        if (urlParts.hostname.match(/^(\w+\.)?twitch\.tv$/i)) {
            twitchMatch = urlParts.pathname.match(/^\/([^\/\.&]+)\/?(.*)$/);
        }
        if (twitchMatch) {
            var parts = {
                channel: twitchMatch[1]
            };
            var partMatch = twitchMatch[2].match(/^(b|c)\/([^\/\.&]+)\/?/);
            if (partMatch && partMatch[1] == 'b') {
                parts.archive = partMatch[2];
            }
            if (partMatch && partMatch[1] == 'c') {
                parts.chapter = partMatch[2];
            }
            return parts;
        }
    },
    gfycatParts: function (urlParts) {
        if (urlParts.hostname.match(/(^|\.)gfycat\.com$/i)) {
            var pathMatch = urlParts.pathname.match(/^\/(?:detail\/)?([^\/&]+)$/);
            if (pathMatch && !_.include([
                'about', 'api', 'terms'
            ], pathMatch[1])) {
                var ret = {
                    gfycat_id: pathMatch[1].split('.')[0].split('-')[0]
                };
                return ret;
            }
        }
    },
    imgurEmbedParts: function (urlParts) {
        if (urlParts.hostname.match(/(^|(www|m|i)\.)imgur\.com$/i)) {
            var pathMatch = urlParts.pathname.match(/^\/(?:(a|(?:gallery)|(?:(?:g|t|r)\/[^\/&]+))\/)?([^\/\.&]{2,})/);
            if (pathMatch) {
                var hashIndex = urlParts.hash.match(/^#?(\d+)$/);
                var idx = 0;
                if (hashIndex) {
                    idx = hashIndex[1] - 0;
                }
                var prefix = '';
                if (pathMatch[1]) {
                    prefix = pathMatch[1] + '/';
                }
                var idList = pathMatch[2].split(',');
                var id = idList[idx];
                return {
                    id: id,
                    prefix: prefix
                };
            }
        }
    },
    wikiParts: function (urlParts) {
        var wikiMatch, titleMatch;
        var hostMatch = urlParts.hostname.match(/\.wiki[pm]edia\.org$/i);
        if (hostMatch) {
            wikiMatch = urlParts.pathname.match(/^\/wiki\/(.*)/);
            if (wikiMatch) {
                titleMatch = wikiMatch[1].match(/^(File:.+)/);
                if (!titleMatch) {
                    titleMatch = urlParts.hash.match(/^#?\/media\/(File:.+)/);
                }
            }
        }
        if (titleMatch) {
            return {
                wiki_host: urlParts.hostname,
                wiki_title: titleMatch[1]
            };
        }
    },
    twitterParts: function (urlParts) {
        var twitterMatch, momentMatch, iwebMatch;
        if (urlUtil.matchTwitter(urlParts)) {
            twitterMatch = urlParts.pathname.match(/^\/([^\/&]+)\/status(?:es)?\/(\d+)\/?/);
            iwebMatch = urlParts.pathname.match(/^\/i\/web\/status\/(\d+)\/?/);
            momentMatch = urlParts.pathname.match(/^\/i\/moments\/(\d+)\/?/);
        }
        if (twitterMatch) {
            return {
                twitter_owner: twitterMatch[1],
                twitter_id: twitterMatch[2]
            };
        } else if (iwebMatch) {
            return {
                twitter_id: iwebMatch[1]
            };
        } else if (momentMatch) {
            return {
                twitter_moment_id: momentMatch[1]
            };
        }
    },
    pinterestParts: function (urlParts) {
        var pinMatch;
        if (urlParts.hostname.match(/(?:^|\.)pinterest\.com$/i)) {
            pinMatch = urlParts.pathname.match(/^\/pin\/(\d+)\/?/);
        }
        if (pinMatch) {
            return {
                pin_id: pinMatch[1]
            };
        }
    },
    xkcdParts: function (urlParts) {
        var xkcdMatch;
        if (urlParts.hostname.match(/^(www\.)?xkcd\.com$/i)) {
            xkcdMatch = urlParts.pathname.match(/^\/(\d+)/);
        }
        if (xkcdMatch) {
            return {
                comic_id: xkcdMatch[1]
            };
        }
    },
    isFlickr: function (urlParts) {
        var flickrMatch;
        if (urlParts.hostname.match(/^(www\.)?flickr\.com$/i)) {
            flickrMatch = urlParts.pathname.match(/^\/photos\/([^\/&]+)\/([^\/\.&]+)\/?/);
        }
        if (!flickrMatch && urlParts.hostname.match(/^(www\.)?flic\.kr$/i)) {
            flickrMatch = urlParts.pathname.match(/^\/p\/([^\/\.&]+)\/?$/);
        }
        return !!flickrMatch;
    },
    instagramParts: function (urlParts) {
        var instagramMatch;
        if (urlUtil.matchInstagram(urlParts)) {
            instagramMatch = urlParts.pathname.match(/^\/((p)|(reel))\/([^\/\.&]+)\/?$/);
        }
        if (instagramMatch) {
            return {
                photo_id: instagramMatch[4],
                insta_type: instagramMatch[1]
            };
        }
    },
    mastodonParts: function (urlParts) {
        var mastodonMatch = urlUtil.matchMastodon(urlParts);
        if (mastodonMatch) {
            return {
                mastodon_origin: urlParts.origin,
                mastodon_username: mastodonMatch[1],
                mastodon_userinstance: mastodonMatch[2],
                mastodon_status: mastodonMatch[3]
            };
        }
    },
    bskyParts: function (urlParts) {
        var bskyMatch;
        if (urlUtil.matchBsky(urlParts)) {
            bskyMatch = urlParts.pathname.match(/^\/profile\/([^\/]+)\/post\/([^\/]+)/);
        }
        if (bskyMatch) {
            var parts = {
                bsky_post: bskyMatch[2]
            };
            if (bskyMatch[1].indexOf('did:') === 0) {
                parts.bsky_did = bskyMatch[1];
            } else {
                parts.bsky_handle = bskyMatch[1];
            }
            return parts;
        }
    },
    redditParts: function (urlParts) {
        var redditMatch;
        if (urlUtil.matchReddit(urlParts)) {
            redditMatch = urlParts.pathname.match(/^\/r\/([^\/]+)\/comments\/([a-z0-9]+)/);
        }
        if (redditMatch) {
            return {
                reddit_sub: redditMatch[1],
                reddit_post: redditMatch[2]
            };
        }
    },
    embedFrame: function (urlParts) {
        var videoParts = this.youTubeParts(urlParts);
        if (videoParts) {
            return this.buildYoutubeFrame(videoParts);
        }
        videoParts = this.vimeoParts(urlParts);
        if (videoParts) {
            return this.buildVimeoFrame(videoParts);
        }
        videoParts = this.tenorParts(urlParts);
        if (videoParts) {
            return this.buildTenorFrame(videoParts);
        }
        videoParts = this.garminParts(urlParts);
        if (videoParts) {
            return this.buildGarminFrame(videoParts);
        }
        videoParts = this.twitchClipParts(urlParts);
        if (videoParts) {
            return this.buildTwitchClipFrame(videoParts);
        }
        videoParts = this.kickstarterParts(urlParts);
        if (videoParts) {
            return this.buildKickstarterFrame(videoParts);
        }
        if (this.isSpotifyEmbed(urlParts)) {
            return this.buildSpotifyFrame(urlParts);
        }
    },
    youTubeParts: function (urlParts) {
        var videoIdMatches, videoId;
        if (urlUtil.matchYouTube(urlParts)) {
            videoIdMatches = urlParts.search.match(/[?&]v=([^"&?\/ ]{11})/) ||
                           urlParts.pathname.match(/^\/(?:v|e|shorts)\/([^"&?\/ ]{11})/);
        } else if (urlParts.hostname.match(/(?:^|\.)youtu\.be$/i)) {
            videoIdMatches = urlParts.pathname.match(/^\/([^"&?\/ ]{11})/);
        }
        if (videoIdMatches) {
            videoId = videoIdMatches[1];
            var ts;
            var tsMatches = urlParts.hash.match(/[#&]t=([^&]+)/) ||
                            urlParts.search.match(/[?&]t=([^&]+)/);
            if (tsMatches) {
                ts = tsMatches[1];
            }
            return {
                vid: videoId,
                ts: ts
            };
        }
    },
    vimeoParts: function (urlParts) {
        var videoIdMatches, videoId;
        if (urlParts.hostname.match(/(?:^|\.)vimeo\.com$/i)) {
            videoIdMatches = urlParts.pathname.match(/^\/(\d+)/);
        }
        if (videoIdMatches) {
            videoId = videoIdMatches[1];
            return {
                vid: videoId
            };
        }
    },
    tenorParts: function (urlParts) {
        var tenorIdMatches, tenorId;
        if (urlParts.hostname.match(/(?:^|\.)tenor\.com$/i)) {
            tenorIdMatches = urlParts.pathname.match(/^\/view\/.*-(\d+)$/);
        }
        if (tenorIdMatches) {
            tenorId = tenorIdMatches[1];
            return {
                id: tenorId
            };
        }
    },
    garminParts: function (urlParts) {
        var activityIdMatches, activityId;
        if (urlParts.hostname.match(/(?:^|\.)garmin\.com$/i)) {
            activityIdMatches = urlParts.pathname.match(/^\/(?:modern\/)?activity\/(?:embed\/)?(\d+)/);
        }
        if (activityIdMatches) {
            activityId = activityIdMatches[1];
            return {
                id: activityId
            };
        }
    },
    kickstarterParts: function (urlParts) {
        if (urlParts.hostname.match(/(?:^|\.)kickstarter\.com$/i)) {
            var projectMatches = urlParts.pathname.match(/^\/projects\/([^/]+)\/([^/]+)/);
            if (projectMatches) {
                return {
                    id: projectMatches[1],
                    name: projectMatches[2]
                };
            }
        }
    },
    twitchClipParts: function (urlParts) {
        var clipMatches;
        if (urlParts.hostname.match(/^clips\.twitch\.tv$/i)) {
            if (urlParts.pathname.match(/^\/embed\/?$/)) {
                clipMatches = urlParts.search.match(/[?&]clip=([^&]+)/);
            } else {
                clipMatches = urlParts.pathname.match(/^\/([A-Z][\w-]+)/);
            }
        } else if (urlParts.hostname.match(/(?:^|\.)twitch\.tv$/i)) {
            clipMatches = urlParts.pathname.match(/^\/[^/]+\/clip\/([^/]+)$/);
        }
        if (clipMatches) {
            return {
                clip: clipMatches[1]
            };
        }
    },
    pastebincomParts: function (urlParts) {
        var idMatches, id;
        if (urlParts.hostname.match(/(?:^|\.)pastebin\.com$/i)) {
            idMatches = urlParts.pathname.match(/^\/(?:raw\/)?([A-Za-z0-9]{8,8})(?:\/|$)/);
        }
        if (idMatches) {
            id = idMatches[1];
            var charTypeMatches = _.filter([
                /[A-Z]/.test(id),
                /[a-z]/.test(id),
                /[0-9]/.test(id)
            ], _.identity);
            if (charTypeMatches.length > 1) {
                return {
                    id: id
                };
            }
        }
    },
    iframeProps: function (allowScrolling) {
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe
        var sandbox = [
            'allow-forms',
            'allow-popups',
            'allow-popups-to-escape-sandbox',
            'allow-same-origin',
            'allow-scripts',
            'allow-presentation'
        ];
        var props = {
            'type': 'text/html',
            'allowfullscreen': 'true',
            'mozallowfullscreen': 'true',
            'webkitallowfullscreen': 'true',
            'sandbox': sandbox.join(' ')
        };
        if (!allowScrolling) {
            props.scrolling = 'no';
        }
        return props;
    },
    buildEmbedFrame: function (src, extraClass, width, height, embedTest, allowScrolling) {
        width = width || VIDEO_WIDTH;
        height = height || VIDEO_HEIGHT;
        embedTest = embedTest || (this.buffer && this.buffer.inlineImagesAllowed());
        var tag = embedTest ? 'iframe' : 'i';
        var className = 'iframeEmbed';
        if (extraClass) {
            className += ' ' + extraClass;
        }
        var ifProps = this.iframeProps(allowScrolling);
        ifProps['class'] = className;
        ifProps['width'] = width;
        ifProps['height'] = height;
        ifProps['src'] = src;
        var pxWidth = /^\d+$/.test(width) ? (width + 'px') : width;
        var pxHeight = /^\d+$/.test(height) ? (height + 'px') : height;
        ifProps['style'] = 'width: ' + pxWidth + '; height: ' + pxHeight + '; max-width: ' + pxWidth;
        var props = this.formatter.makeAttributes(ifProps);
        var frame = '<' + tag + ' ' + props + '></' + tag + '>';
        return [frame, width, extraClass];
    },
    buildYoutubeFrame: function (parts) {
        var params = {
            autohide: 1,
            controls: 1,
            // enablejsapi: 1,
            // playerapiid: 'TODO',
            rel: 1,
            showinfo: 1,
            start: this.ytStart(parts.ts),
            fs: 1,
            iv_load_policy: 3,
            modestbranding: 1,
            autoplay: 0
        };
        if (this.buffer) {
            params.origin = this.buffer.session.getOrigin();
        }
        var src = 'https://www.youtube.com/embed/' +
            this.formatter.escapeText(encodeURIComponent(parts.vid)) + '?' +
            $.param(params);
        return this.buildEmbedFrame(src, 'video');
    },
    buildVimeoFrame: function (parts) {
        var src = 'https://player.vimeo.com/video/' +
            this.formatter.escapeText(encodeURIComponent(parts.vid));
        return this.buildEmbedFrame(src, 'video');
    },
    buildTenorFrame: function (parts) {
        var params = {};
        if (this.buffer) {
            params.canonicalurl = this.buffer.session.getOrigin();
        }
        var src = 'https://tenor.com/embed/' +
            this.formatter.escapeText(encodeURIComponent(parts.id)) + '?' +
            $.param(params);
        return this.buildEmbedFrame(src, 'tenor video', VIDEO_WIDTH, VIDEO_WIDTH/1.33);
    },
    buildGarminFrame: function (parts) {
        var src = 'https://connect.garmin.com/activity/embed/' +
            this.formatter.escapeText(encodeURIComponent(parts.id));
        return this.buildEmbedFrame(src, 'garmin video', 465, 500);
    },
    buildSpotifyFrame: function (parts) {
        // Remove the hash, timestamp links don't work anymore and mess up the embed
        parts.hash = '';
        var src = 'https://embed.spotify.com/?uri=' +
            this.formatter.escapeText(encodeURIComponent(parts.href));
        return this.buildEmbedFrame(src, 'spotify video', VIDEO_WIDTH, 80);
    },
    buildPastebinComFrame: function (parts) {
        var src = 'https://pastebin.com/embed_iframe/' +
            this.formatter.escapeText(encodeURIComponent(parts.id));
        return this.buildEmbedFrame(
            src,
            'pastebincom',
            '100%', 190,
            (this.buffer && this.buffer.inlinePastesAllowed()),
            true
        );
    },
    buildKickstarterFrame: function (parts) {
        var src = 'https://www.kickstarter.com/projects/' +
            this.formatter.escapeText(encodeURIComponent(parts.id)) + '/' +
            this.formatter.escapeText(encodeURIComponent(parts.name)) +
            '/widget/video.html'; // card.html;
        return this.buildEmbedFrame(src, 'kickstarter video');
    },
    buildTwitchClipFrame: function (parts) {
        var src = 'https://clips.twitch.tv/embed?autoplay=false&parent=' + 
            this.formatter.escapeText(encodeURIComponent(this.host())) + '&clip=' +
            this.formatter.escapeText(encodeURIComponent(parts.clip));
        return this.buildEmbedFrame(src, 'video');
    },
    ytStart: function (startString) {
        if (!startString) {
            return;
        }
        startString = startString.toLowerCase();
        var startHSplit = startString.split('h');
        var startMSplit;
        var h, m, s;
        if (startHSplit[1] === '') {
            h = startHSplit[0] - 0;
            m = 0;
            s = 0;
        } else {
            if (startHSplit[1]) {
                h = startHSplit[0] - 0;
                startMSplit = startHSplit[1].split('m');
            } else {
                h = 0;
                startMSplit = startHSplit[0].split('m');
            }
            var startSSplit;
            if (startMSplit[1]) {
                m = startMSplit[0] - 0;
                startSSplit = startMSplit[1].split('s');
                s = startSSplit[0] - 0;
            } else if (startMSplit[1] === '') {
                m = startMSplit[0] - 0;
                s = 0;
            } else {
                m = 0;
                startSSplit = startMSplit[0].split('s');
                s = startSSplit[0] - 0;
            }
        }
        return s + (((h * 60) + m) * 60);
    },
    isSpotifyEmbed: function (urlParts) {
        if (urlUtil.isSpotify(urlParts.href)) {
            return true;
        }
        if (urlParts.hostname.match(/^open\.spotify\.com$/i)) {
            return true;
        }
        return false;
    },
    isSoundcloudEmbed: function (urlParts) {
        return !!urlParts.hostname.match(/^((?:www|api)\.)?soundcloud\.com$/i);
    },
    isStreamableCom: function (urlParts) {
        // https://streamable.com/3bse
        if (urlParts.hostname.match(/(?:^|\.)streamable\.com$/i)) {
            if (urlParts.pathname.match(/^\/([^\/&]+)/)) {
                return true;
            }
        }
        return false;
    },
    renderUrl: function (url, options) {
        options = options || {};
        url = util.stringify(urlUtil.escapeRTLO(url));
        var htmlContent = this.formatter.escapeText(url);
        var className = 'link';
        var target = null;
        var frame;
        var allowEmbed = !options.inBlock;
        var data = {};
        var embed = '';
        var loading;
        var videoWidth;
        var after;
        var httpAdded = false;
        if (this.isChannelName(url)) {
            if (this.buffer) {
                className = 'buffer bufferLink channel';
                allowEmbed = false;
                data.cid = this.buffer.getCid();
                data.name = url;
                data.bid = this.buffer.bid();
                url = this.buffer.connection.buildUrl([
                    'channel', this.buffer.connection.channelSlug(url)
                ]);
            }
        } else {
            target = "_blank";
            var protocolMatch = urlUtil.protoMatch(url);
            var ircParts;
            if (!protocolMatch) {
                if (urlUtil.isEmail(url)) {
                    // Email address
                    url = 'mailto:' + url;
                    className = 'email';
                    allowEmbed = false;
                } else if (url.indexOf('irc.') === 0) {
                    // Make a network link if it starts with irc.
                    ircParts = util.ircUrlParts('irc://' + url);
                    if (ircParts) {
                        target = null;
                        allowEmbed = false;
                        className = 'buffer bufferLink irc';
                        url = Connection.buildLegacyUrl(ircParts.root, ircParts.label);
                        data.url = url;
                        url = '/' + url;
                    }
                } else if (
                    !urlUtil.isSpotify(url) &&
                    !urlUtil.isSkype(url) &&
                    !urlUtil.isMagnet(url)
                ) {
                    // Prepend http if there's no protocol and it's not a spotify link
                    httpAdded = true;
                    url = 'http://' + url;
                }
            } else if (!urlUtil.isHttp(protocolMatch[0])) {
                if (urlUtil.isLooseHttp(protocolMatch[0])) {
                    var p = urlUtil.urlParts(url);
                    if (p) {
                        url = p.href;
                    }
                } else {
                    allowEmbed = false;
                    target = null;
                    if (urlUtil.isIrc(protocolMatch[0])) {
                        // Convert to network link
                        ircParts = util.ircUrlParts(url);
                        if (ircParts) {
                            className = 'buffer bufferLink irc';
                            url = Connection.buildLegacyUrl(ircParts.root, ircParts.label);
                            data.url = url;
                            url = '/' + url;
                        } else {
                            target = "_blank";
                        }
                    } else if (urlUtil.isFtp(protocolMatch[0])) {
                        // https://code.google.com/p/chromium/issues/detail?id=30892
                        // FTP url's should open in default app on Mac OS X
                        // (affects firefox too)
                        // (doesn't affect safari, but it will complain about mime types, so stick to new window for safety)
                        target = "_blank";
                    } else if (!$.browser.safari) {
                        // https://bugzilla.mozilla.org/show_bug.cgi?id=667865
                        // Clicking a non-http protocol url erroneously triggers the onbeforeunload event
                        // (chrome does the same now)
                        // Safari handles protocol urls fine, no retargeting needed
                        target = "_blank";
                    }
                }
            }
        }
        var urlParts = urlUtil.urlParts(url);
        if (!urlParts) {
            return;
        }
        if (urlParts.username || urlParts.password) {
            if (httpAdded) {
                return;
            }
            var userPass = '<span class="urlUserPass"> (';
            var hiddenUserPass = '';
            if (urlParts.username) {
                userPass += 'username: ' + this.formatter.escapeText(urlParts.username);
                if (urlParts.password) {
                    userPass += ' ';
                }
                hiddenUserPass += this.formatter.escapeText(
                    encodeURIComponent(urlParts.username)
                );
            }
            if (urlParts.password) {
                userPass += 'password: ' + this.formatter.escapeText(urlParts.password);
                hiddenUserPass += this.formatter.escapeText(
                    ':' + encodeURIComponent(urlParts.password)
                );
            }
            userPass += ')</span>';
            after = userPass;
            htmlContent = this.formatter.escapeText(urlParts.protocol + '//');
            htmlContent += '<span class="urlUserPassHidden">';
            htmlContent += hiddenUserPass;
            htmlContent += '@</span>';
            htmlContent += this.formatter.escapeText(
                urlParts.host + urlParts.pathname + urlParts.search + urlParts.hash
            );
        }
        if (this.isCurrentUrl(urlParts)) {
            if (urlParts.pathname == '/') {
                url = urlParts.search + urlParts.hash;
            } else {
                url = urlParts.pathname + urlParts.search + urlParts.hash;
            }
            target = null;
        } else if (options.embeds && allowEmbed) {
            // We use assignment in conditionals here to avoid
            // nesting hell
            var gistParts,
                pasteParts,
                instagramParts,
                twitterParts,
                imgurEmbedParts,
                wikiParts,
                pinParts,
                xkcdParts,
                gfycatParts,
                mastodonParts,
                bskyParts,
                redditParts,
                imageUrl,
                pastebincomParts;
            if ((gistParts = this.gistParts(urlParts))) {
                className = 'gist';
                loading = true;
                data = _.extend({}, data, gistParts);
            } else if ((pasteParts = this.pasteParts(urlParts))) {
                className = 'paste';
                loading = true;
                if (options.embeds && options.embeds.pastes) {
                    var entity = _.find(options.embeds.pastes, function (paste) {
                        return paste.id == pasteParts.paste_id;
                    });
                    if (entity) {
                        for (var k in entity) {
                            pasteParts['paste_' + k] = entity[k];
                        }
                    }
                }
                data = _.extend({}, data, pasteParts);
            } else if (this.isFlickr(urlParts)) {
                className = 'flickr';
                loading = true;
            } else if ((instagramParts = this.instagramParts(urlParts))) {
                className = 'instagram';
                loading = true;
                data = _.extend({}, data, instagramParts);
            } else if (this.isSoundcloudEmbed(urlParts)) {
                className = 'soundcloud';
                loading = true;
            } else if (this.isStreamableCom(urlParts)) {
                className = 'streamablecom';
                loading = true;
            } else if ((twitterParts = this.twitterParts(urlParts))) {
                className = 'twitter';
                loading = true;
                data = _.extend({}, data, twitterParts);
            } else if ((imgurEmbedParts = this.imgurEmbedParts(urlParts))) {
                className = 'imgur';
                loading = true;
                data.imgur_embed = imgurEmbedParts.id;
                data.imgur_embed_prefix = imgurEmbedParts.prefix;
            } else if ((wikiParts = this.wikiParts(urlParts))) {
                className = 'wiki';
                loading = true;
                data = _.extend({}, data, wikiParts);
            } else if ((pinParts = this.pinterestParts(urlParts))) {
                className = 'pinterest';
                loading = true;
                data = _.extend({}, data, pinParts);
            } else if ((xkcdParts = this.xkcdParts(urlParts))) {
                className = 'xkcd';
                loading = true;
                data = _.extend({}, data, xkcdParts);
            } else if ((gfycatParts = this.gfycatParts(urlParts))) {
                className = 'gfycat';
                loading = true;
                data = _.extend({}, data, gfycatParts);
            } else if ((mastodonParts = this.mastodonParts(urlParts))) {
                className = 'mastodon';
                loading = true;
                data = _.extend({}, data, mastodonParts);
            } else if ((bskyParts = this.bskyParts(urlParts))) {
                className = 'bsky';
                loading = true;
                data = _.extend({}, data, bskyParts);
            } else if ((redditParts = this.redditParts(urlParts))) {
                className = 'reddit';
                loading = true;
                data = _.extend({}, data, redditParts);
            } else if ((imageUrl = this.imageUrl(urlParts, url, options.message))) {
                var tag = (this.buffer && this.buffer.inlineImagesAllowed()) ? 'img' : 'i';
                embed = '<' + tag + ' src="' + this.formatter.escapeText(imageUrl) + '" class="image loading"></' + tag + '>';
                className = 'image';
            } else if ((pastebincomParts = this.pastebincomParts(urlParts))) {
                frame = this.buildPastebinComFrame(pastebincomParts);
                embed = frame[0];
                className = 'pastebincom';
            } else if ((frame = this.embedFrame(urlParts))) {
                embed = frame[0];
                videoWidth = frame[1];
                if (frame[2]) {
                    className = frame[2];
                } else {
                    className = 'video';
                }
            }
        }
        return {
            html: htmlContent,
            url: url,
            className: className,
            target: target,
            data: data,
            embed: embed,
            loading: loading,
            videoWidth: videoWidth,
            after: after,
            parts: urlParts
        };
    },
    makeLinkFromBits: function (html, bits, extraClass) {
        var className = bits.className;
        if (extraClass) {
            className += ' ' + extraClass;
        }
        if (bits.loading) {
            className += ' loading';
        }
        return this.make(html, _.extend({
            href: bits.url,
            'class': className,
            'rel': 'noreferrer',
            target: bits.target,
            data: bits.data
        }, bits.attrs)) + (bits.after || '');
    },
    makeLinkFromUrl: function (url, html, attrs) {
        html = html || url;
        var parts = this.splitTextOnUrls(url);
        if (parts && parts.length === 1 && parts[0].url) {
            var bits = this.renderUrl(parts[0].url);
            if (bits) {
                bits.attrs = attrs;
                delete bits.after;
                delete bits.loading;
                return this.makeLinkFromBits(html, bits);
            }
        }
    },
    make: function (html, attributes, button) {
        var tag = 'a';
        if (button) {
            delete attributes.href;
            attributes['class'] += ' link';
            tag = button || 'button';
        }
        if (attributes.href) {
            var urlParts = urlUtil.urlParts(attributes.href);
            if (urlUtil.isDisallowed(urlParts.protocol)) {
                return html + ': ' + this.formatter.escapeText(attributes.href);
            } else {
                attributes.href = urlParts.href;
            }
        }
        return '<' + tag + this.formatter.makeAttributes(attributes)+ '>' + html + '</' + tag + '>';
    },
    isUnbalanced: function (url) {
        var lastChar = url.slice(-1);
        return lastChar in QUOTES &&
            url.split(lastChar).length !== url.split(QUOTES[lastChar]).length;
    },
    cutBackUrl: function (url, prefix) {
        return url.slice(0, url.indexOf(prefix) + prefix.length);
    },
    splitTextOnUrls: function (text, textIndex) {
        textIndex = textIndex || 0;
        text = util.stringify(text);
        // Extract URLs and hashes
        var urls = [];
        try {
            urls = text.match(this.regex);
        } catch (e) {
            debug.error(e, text);
        }
        // Split text into linkable parts
        var textParts = [];
        var parsedIndex = 0;
        var prevWasText = false;
        var prevIdx = -1;
        if (urls) {
            _.each(urls, function (url, i) {
                var textValue = text.slice(parsedIndex, text.indexOf(url, parsedIndex));
                if (textValue !== '') {
                    if (prevWasText) {
                        textParts[prevIdx].value += textValue;
                    } else {
                        textParts.push({
                            value: textValue,
                            index: textIndex + parsedIndex
                        });
                        prevIdx++;
                        prevWasText = true;
                    }
                }
                var part = {
                    index: textIndex + parsedIndex + textValue.length
                };
                parsedIndex += textValue.length + url.length;

                var prevChar = textValue.slice(-1);

                // Strip trailing punctuation
                var trailPuncMatch, innerPunc;
                while (url && (trailPuncMatch = urlUtil.trailingPuncMatch(url))) {
                    innerPunc = trailPuncMatch[0][0];
                    if (innerPunc in QUOTES && prevChar != QUOTES[innerPunc]) {
                        break;
                    }
                    url = url.slice(0, -trailPuncMatch[0].length);
                    parsedIndex -= trailPuncMatch[0].length;
                }
                var closeParenMatch;
                while (url && (closeParenMatch = urlUtil.closeParenMatch(url))) {
                    innerPunc = closeParenMatch[0][0];
                    if (innerPunc in QUOTES && prevChar != QUOTES[innerPunc]) {
                        break;
                    }
                    parsedIndex -= url.slice(closeParenMatch.index).length;
                    url = url.slice(0, closeParenMatch.index);

                }
                var protoStrip = urlUtil.protoStrip(url);
                var domainParts = urlUtil.domainSplit(protoStrip);
                if (!urlUtil.isEmail(url) && (domainParts[1] || domainParts[0] === protoStrip)) {
                    var colonParts = domainParts[0].split(':');
                    // Non-digit after colon and first part doesn't
                    // contain ?#/ then stop matching before the colon
                    var preColon = colonParts[0];

                    var postColonPart = 1;
                    var postColon = colonParts[postColonPart];
                    if (urlUtil.domainMatch(preColon)) {
                        if (postColon && postColon.indexOf('@') !== -1) {
                            // User/password, check next value
                            preColon += ':' + postColon;
                            postColonPart = 2;
                            postColon = colonParts[postColonPart];
                        }
                        var newUrl;
                        var domainSplit = urlUtil.domainEndSplit(domainParts[0]);
                        if (postColon) {
                            var cutBack;
                            if (
                                postColon.match(/^\d+/) ||
                                // +6697 indicates ircs in irc urls
                                (urlUtil.isIrc(url) && postColon.match(/^\+(\d+)$/))
                            ) {
                                // port digit matched, shouldn't have more parts
                                if (colonParts[postColonPart + 1]) {
                                    preColon += ':' + postColon;
                                    cutBack = true;
                                }
                            } else if (!urlUtil.domainEndMatch(preColon)) {
                                // no port digit matched, previous part doesn't contain
                                // a domain ender
                                cutBack = true;
                            }
                            if (cutBack) {
                                // Only match url up to the colon
                                var preColonSplit = urlUtil.domainEndSplit(preColon);
                                if (preColonSplit[1] !== undefined) {
                                    preColon = preColonSplit[0];
                                }
                                newUrl = this.cutBackUrl(url, preColon);
                                parsedIndex -= url.length - newUrl.length;
                                url = newUrl;
                            } else if (domainSplit[1] !== undefined) {
                                newUrl = this.cutBackUrl(url, domainSplit[0]);
                                parsedIndex -= url.length - newUrl.length;
                                url = newUrl;
                            }
                        } else if (domainSplit[1] !== undefined) {
                            newUrl = this.cutBackUrl(url, domainSplit[0]);
                            parsedIndex -= url.length - newUrl.length;
                            url = newUrl;
                        }
                    }
                }

                var nextChar = text[parsedIndex];
                var nextChar2 = text[parsedIndex+1];
                while (this.isUnbalanced(url)) {
                    // Don't include last character if it's unbalanced
                    url = url.slice(0, -1);
                    parsedIndex--;
                }

                if (urlUtil.isDangerousString(url)) {
                    // strings that crash browsers
                } else if (nextChar =='.' && nextChar2 && nextChar2.match(/\w/)) {
                    // looks like a class path e.g. java.security.SecureRandom
                } else if (prevChar == '&' && url[0] == '#') {
                    // colour code
                } else if ($.inArray(prevChar, ['/', '\\']) !== -1) {
                    // previous char is slash, e.g. a file path
                } else if (urlUtil.isEmail(url) && nextChar == '/') {
                    // next char after email is slash
                } else if (url == '#') {
                    // bare hash, (probably due to trailing punc)
                } else if (this.isChannelName(url) && urlUtil.isNum(url.slice(1))) {
                    // #1 numeral
                } else if (urlUtil.isBareHttp(url)) {
                    // Don't match bare http links
                } else if (urlUtil.isDisallowed(url)) {
                    // Don't match disallowed links
                } else {
                    part.url = url;
                }
                part.value = url;
                if (part.url) {
                    textParts.push(part);
                    prevIdx++;
                    prevWasText = false;
                } else {
                    if (prevWasText) {
                        textParts[prevIdx].value += part.value;
                    } else {
                        textParts.push(part);
                        prevIdx++;
                        prevWasText = true;
                    }
                }
            }, this);
        }
        var textValue = text.slice(parsedIndex);
        if (textValue !== '') {
            if (prevWasText) {
                textParts[prevIdx].value += textValue;
            } else {
                textParts.push({
                    value: textValue,
                    index: textIndex + parsedIndex
                });
            }
        }
        return textParts;
    }
});


module.exports = linker;



//////////////////
// WEBPACK FOOTER
// ./app/src/format/autolinker.js
// module id = INx5
// module chunks = 1